import styled from 'styled-components';

import PageContainer from '@ui/organisms/PageContainer';

import useGradient from '@hooks/useGradient';

import theme from '@theme/FolxTheme';

const FlowPageContainer = styled(PageContainer)<{ showGradient?: boolean }>`
	min-height: 100vh;
	background: ${({ showGradient = false }) => !showGradient && theme.colors.white};
	${({ showGradient = false }) => useGradient(showGradient)}
`;

export default FlowPageContainer;
